import React from 'react';

interface IProperties {
  album?: boolean;
  dateAdded?: boolean;
}

const TrackTableHead = ({ album, dateAdded }: IProperties) => {
  return (
    <div className="flex flex-row justify-between gap-4 items-center px-4 py-1 border-b-[1px] border-theme-light-gray/25 mb-4">
      <div className="flex justify-center items-center w-4 text-center h-full">
        <span className="material-icons cursor-default text-lg text-theme-light-gray">
          tag
        </span>
      </div>

      <span className="flex-[3] text-theme-light-gray text-sm cursor-default">
        Title
      </span>

      {album && (
        <span className="flex-[2] text-theme-light-gray text-sm cursor-default">
          Album
        </span>
      )}

      {dateAdded && (
        <span className="flex-[2] text-theme-light-gray text-sm cursor-default">
          Date Added
        </span>
      )}

      <span
        className={
          'material-icons text-lg cursor-default text-transparent invisible'
        }
      >
        favorite
      </span>

      <span className="ml-4 material-icons cursor-default text-xl text-theme-light-gray w-10">
        schedule
      </span>
    </div>
  );
};

export default TrackTableHead;
